"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importStar(require("../icon/Icon"));
var DeprecationUtils_1 = require("../../utils/DeprecationUtils");
var DropDownSelectableItem = /** @class */ (function (_super) {
    __extends(DropDownSelectableItem, _super);
    function DropDownSelectableItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            _this.props.onClick();
        };
        return _this;
    }
    DropDownSelectableItem.prototype.render = function () {
        var _a = this.props, classes = _a.classes, children = _a.children, iconName = _a.iconName, isSelected = _a.isSelected, selected = _a.selected;
        if (isSelected) {
            DeprecationUtils_1.logDeprecatedProp({
                component: 'DropDownSelectableItem',
                propName: 'isSelected',
                seeMsg: 'Pass selected instead of isSelected to <DropDownSelectableItem>',
                versionStart: '1.0.0-beta.169',
                versionEnd: '2.0.0'
            });
        }
        return (react_1.default.createElement("div", { className: classnames_1.default('fds-dropdown-selectable-item', { 'fds-dropdown-selectable-selected': isSelected || selected }, classes), onClick: this.onClick },
            iconName && react_1.default.createElement(Icon_1.default, { name: iconName, size: Icon_1.IconSize.SMALL }),
            react_1.default.createElement("span", { className: "fds-dropdown-selectable-label" }, children)));
    };
    DropDownSelectableItem.defaultProps = {
        iconName: 'done',
        isSelected: false
    };
    return DropDownSelectableItem;
}(react_1.default.Component));
exports.default = DropDownSelectableItem;
